import './gerczaks1/style';
import FormStructure from './gerczaks1/form_structure';

export default FormStructure;